import { FlashcardState } from "./types";
import { DetailedLoadStatus } from "../../../../../../../common/utils/async-status";
import { fetchDeck, updateDeck } from "../decks/actions";
import { createFlashcard, deleteFlashcard, updateFlashcard } from "./actions";
import { SET_SELECTED_DECK } from "../decks/types";

const initialState = {
  flashcardData: {},
  loadStatus: DetailedLoadStatus.OK,
  error: null,
} as FlashcardState;

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchDeck.fulfilled.type:
    case updateDeck.fulfilled.type:
      return {
        ...state,
        flashcardData: Object.assign(
          {},
          state.flashcardData,
          action.payload.entities.cards
        ),
        loadStatus: DetailedLoadStatus.OK,
        error: null,
      };
    case createFlashcard.rejected.type:
    case updateFlashcard.rejected.type:
    case deleteFlashcard.rejected.type:
    case fetchDeck.rejected.type:
      return {
        ...state,
        loadStatus: DetailedLoadStatus.ERROR,
        error: action.payload,
      };
    case fetchDeck.pending.type:
      return {
        ...state,
        loadStatus: DetailedLoadStatus.FETCHING,
        error: null,
      };
    case createFlashcard.fulfilled.type:
      return {
        ...state,
        error: null,
        flashcardData: Object.assign(
          {},
          state.flashcardData,
          action.payload.entities.cards
        ),
      };
    case updateFlashcard.fulfilled.type:
      return {
        ...state,
        error: null,
        flashcardData: Object.assign(
          {},
          state.flashcardData,
          action.payload.entities.cards
        ),
      };
    case deleteFlashcard.fulfilled.type:
      const flashcardDataCopy = { ...state.flashcardData };
      delete flashcardDataCopy[action.meta.arg.id];
      return {
        ...state,
        error: null,
        flashcardData: flashcardDataCopy,
      };
    case SET_SELECTED_DECK:
      return {
        ...state,
        error: null,
        loadStatus: DetailedLoadStatus.WAITING,
      };
    default:
      return state;
  }
};
